import { Text } from "@carbon6/c6-frontend-design";
import { annotationBundleIssueText, type DatasetUploadAssets } from "@/modules/dataset/public";
import { hatcheryTextModes } from "@/app/theme";
import styles from "./UploadBundleSummary.module.css";

export function UploadBundleSummary({ assets }: { assets: DatasetUploadAssets | null }) {
  if (!assets || (!assets.annotation && assets.maskCount === 0)) return null;
  const bundle = assets.annotation;
  const issues = [...(bundle?.issues ?? []), ...assets.maskIssues];
  return (
    <section className={styles.summary} aria-label="Annotation과 mask 파일 요약">
      {bundle && (
        <Text variant={hatcheryTextModes["caption-normal"]}>
          Annotation 파일 {bundle.fileCount}개
          {bundle.keyframeCount !== null
            ? ` · keyframe ${bundle.keyframeCount}개 · 카메라 ${bundle.cameras.length}개`
            : ""}
        </Text>
      )}
      {assets.maskCount > 0 && (
        <Text variant={hatcheryTextModes["caption-normal"]}>
          mask {assets.maskCount}개 · 카메라 {assets.maskCameras.length}개
        </Text>
      )}
      {issues.length > 0 && (
        <ul className={styles.issues}>
          {issues.map((issue) => (
            <li key={issue.code}>
              <Text variant={hatcheryTextModes["caption-normal"]}>
                {annotationBundleIssueText(issue)}
              </Text>
            </li>
          ))}
        </ul>
      )}
      <Text variant={hatcheryTextModes["caption-normal"]}>
        Dataset 업로드는 계속 진행할 수 있습니다. 업로드 후 검증을 통과한 Annotation 번들만 세트로
        등록하며, mask는 원본과 프레임 수를 확인합니다.
      </Text>
    </section>
  );
}
